import type { OnInit } from '@angular/core';
import { Component, HostListener, Pipe } from '@angular/core';
import { WebBaseViewComponent } from '@web/widgets/common/abstract/web-base-view.component';
import { CardViewType, type ProductCardWidgetData } from '@web/widgets/product-card/type';
import { getStyles } from './product-card-view.component.styles';
import { Attachment } from '../../type/product-card-widget.type';
import { TranslateModule } from '@ngx-translate/core';
import { OpenViewCardComponent } from './open-view-card/open-view-card.component';
import { ModalViewCardComponent } from './modal-view-card/modal-view-card.component';

@Component({
    selector: 'web-product-card-view',
    templateUrl: './product-card-view.component.html',
    styleUrls: ['./product-card-view.component.less'],
    imports: [ModalViewCardComponent, OpenViewCardComponent, TranslateModule],
})
export class ProductCardViewComponent extends WebBaseViewComponent<ProductCardWidgetData> implements OnInit {
    protected getStyles = getStyles;

    public attachment = Attachment;

    @HostListener('window:scroll', ['$event']) onWindowScroll(e) {
        // console.log(e.target['scrollingElement'].scrollTop);
        // console.log(112321231, e);
        // Your Code Here
    }

    ngOnInit() {
        super.ngOnInit();
        this.layoutFacade.setIsHideColumnControls(this.openCardType);
    }

    public get element() {
        return this.widgetData?.element;
    }

    public get isShowCardSettings(): boolean {
        return this.widgetData.isShowCardSettings;
    }

    /**
     * The CRM no longer has this product. The card stays on the canvas — dimmed, with a notice —
     * so the author can see which product went missing and swap it for another one. The published
     * site is the opposite: there the widget is left out entirely.
     */
    public get isRemovedFromCatalog(): boolean {
        return !!this.element?.isRemovedFromCatalog;
    }

    private get cardViewType(): CardViewType {
        return this.widgetData.cardViewType;
    }

    public get modalCardType(): boolean {
        return this.cardViewType === CardViewType.modal;
    }

    public get openCardType(): boolean {
        return this.cardViewType === CardViewType.open;
    }
}
